import './assets/site.css';

import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import Alpine from 'alpinejs';

Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(focus);

import {
  navComponent,
  overlayStore,
  imageCarouselComponent,
  imageCarouselMultiComponent,
} from '@/Components/components';
import {
  loadComponents,
  conditionCategoryFilterComponent,
} from '@/Features/feature-components';
import { patchFormHelper } from '@/src/utilities/custom-form-helper';

loadComponents();

navComponent(Alpine);
overlayStore(Alpine);
conditionCategoryFilterComponent(Alpine);

imageCarouselComponent(Alpine);
imageCarouselMultiComponent(Alpine);

Alpine.start();
window.alpine = Alpine;

patchFormHelper();
